








































import { getDefaultThumbnailForProductType } from '@/web/utils/media';
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'ProductThumbnail',
  props: {
    product: {
      type: Object as () => ProductResponse,
      required: true,
    },
    hideOverlay: {
      type: Boolean,
      default: false,
    },
    static: {
      // removes any pricing information
      type: Boolean,
      default: false,
    },
    isSelectable: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    isGift: {
      type: Boolean,
      default: false,
    },
    fullSize: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      currency: 'studio/currency',
    }),
    style(): object | null {
      if (this.product.thumbnail_file) {
        const file = this.product.thumbnail_file as PhotoResponse;
        let thumbnailUrl = file.thumbnail;
        if (this.fullSize && file.image_url) thumbnailUrl = file.image_url;
        return {
          backgroundImage: 'url(' + thumbnailUrl + ')',
          backgroundSize: 'cover',
        };
      }
      if (this.product.cover_file) {
        const file = this.product.cover_file as PhotoResponse;
        let thumbnailUrl = file.thumbnail;
        if (this.fullSize && file.image_url) thumbnailUrl = file.image_url;
        return {
          backgroundImage: 'url(' + thumbnailUrl + ')',
          backgroundSize: 'cover',
        };
      }
      const thumbnailUrl = getDefaultThumbnailForProductType(
        this.product?.product_type
      );
      return {
        backgroundImage: 'url(' + thumbnailUrl + ')',
      };
    },
    status() {
      const isNew = moment(this.product.created).isAfter(
        moment().subtract({ days: this.product.media_new_tag_days })
      );
      if (this.product.gifted) {
        return 'gifted';
      } else if (
        this.product.purchased &&
        this.product.pricing_type === 'free'
      ) {
        return 'registered';
      } else if (this.product.purchased) {
        return 'purchased';
      } else if (this.product.is_featured) {
        return 'featured';
      } else if (isNew) {
        return 'new';
      } else {
        return null;
      }
    },
  },
};
